// extracted by mini-css-extract-plugin
export var container = "_ec-0";
export var content = "_ec-3";
export var customerTitle = "_ec-4";
export var empty = "_ec-5";
export var gray = "_ec-6";
export var header = "_ec-7";
export var info = "_ec-8";
export var loading = "_ec-2";
export var loadingCard = "_ec-9";
export var oneLine = "_ec-a";
export var personName = "_ec-e";
export var pillContainer = "_ec-b";
export var selected = "_ec-1";
export var text = "_ec-c";
export var twoLines = "_ec-d";
export var unread = "_ec-f";
export var unreadIndicator = "_ec-g";